import { CREATE_PROFILE_REQUEST, CREATE_PROFILE_REQUEST_ERROR, CREATE_PROFILE_REQUEST_SUCCESS, CREATE_USER_REQUEST, CREATE_USER_REQUEST_ERROR, CREATE_USER_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const registerReducer = (state = initialState, action) => {
    switch (action.type) {
    case CREATE_USER_REQUEST:        
        return { ...state, payload : action.payload, loading: true };
    case CREATE_USER_REQUEST_SUCCESS :       
        return { ...state, successMsg : action.msg, successCreateProfileMsg : null, loading: false };
    case CREATE_USER_REQUEST_ERROR :
        return { ...state,loading: false };
    case CREATE_PROFILE_REQUEST:        
        return { ...state, payload : action.payload, loading: true };
    case CREATE_PROFILE_REQUEST_SUCCESS :       
        return { ...state, successCreateProfileMsg : action.msg, successMsg : null, loading: false };
    case CREATE_PROFILE_REQUEST_ERROR :
        return { ...state,loading: false };
    default:
        return state;
    }
};
  